<template>
  <v-expansion-panel v-if="canView && recordId">
    <v-expansion-panel-header>Zones</v-expansion-panel-header>
    <v-expansion-panel-content>
      <ZoneAssignmentsField :record-type="recordType" :record-id="recordId" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  import ZoneAssignmentsField from './ZoneAssignmentsField.vue';
  import permissions from '@Share/config/permissions';
  import { $has } from '@/utils';

  /**
   * The Zones section of a tag or task card (AVA-764): a panel for the card's v-expansion-panels.
   * Place it last in the panel list, so the cards' index-based expanded sections don't shift.
   */
  export default {
    name: 'RecordZonesPanel',
    components: { ZoneAssignmentsField },
    props: {
      recordType: { type: String, required: true },
      recordId: { type: String, default: null },
    },
    computed: {
      canView() {
        return $has([permissions.Zones.View, permissions.Zones.Manage, permissions.Zones.Assign], true);
      },
    },
  };
</script>
